import React from 'react';
import logo from "../assets/images/logo.png";

const Loading = () => {
  return (
    <div>
        <div className='topbar' style={{zIndex:1}}>
          <img src={logo} alt="logo"/>
        </div>
    <div className='centerLoader'>
       <span className='loader'></span>
    </div>
    <div className='footer-consent' >
            <p style={{margin:0,marginRight:10}}>
                Copyright Old Mutual Limited 2022 <span style={{margin:30}}>|</span> <a 
                style={{textDecoration:'none',color:'#fff'}}
                href="https://www.oldmutual.co.zw/about-us/privacy-policy/" target="_blank">Privacy Policy</a>
            </p>
      </div>
    </div>
  )
}

export default Loading